import { OktaAuth } from '@okta/okta-auth-js'

const authConfig = {
  clientId: OE_ENV.CLIENT_ID,
  issuer: `${OE_ENV.OKTA_BASE_URL}/oauth2/${OE_ENV.OKTA_AUTH_SERVER}`,
  redirectUri: OE_ENV.REDIRECT_URI,
  postLogoutRedirectUri: OE_ENV.POST_LOGOUT_REDIRECT_URI,
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
}

const oktaAuth = new OktaAuth(authConfig)

export default oktaAuth
